// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7130cc18","703":"dc803d9e"}[chunkId] + ".chunk.js";
};